"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgRss(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M4.34 15.32a4.34 4.34 0 110 8.68 4.34 4.34 0 010-8.68zm0 1.531a2.807 2.807 0 00-2.808 2.809A2.809 2.809 0 104.34 16.85zM4.7 0c10.525 0 19.112 8.472 19.297 18.954L24 19.3v1.891a.766.766 0 01-1.525.104l-.007-.104v-1.89c0-9.684-7.793-17.588-17.435-17.766L4.7 1.532H2.809A.766.766 0 012.705.007L2.809 0h1.89zm-.96 8.172c6.566 0 11.923 5.255 12.086 11.781l.004.307v.931a.766.766 0 01-1.525.104l-.007-.104v-.93c0-5.726-4.579-10.399-10.268-10.553l-.29-.004h-.931a.766.766 0 01-.104-1.525l.104-.007h.93z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgRss;
exports.default = _default;